import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateFormatterPipe } from '../pipes/date-formatter.pipe';
import { MultiSelectCheckboxComponent } from '../components/multi-select-checkbox/multi-select-checkbox.component';

import { FormsModule, NG_VALIDATORS, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from './angular-material.module';
import { ErrorMesssageComponent } from '../components/error-messsage/error-messsage.component';
import { AuthenticationPopupComponent } from '../components/authentication-popup/authentication-popup.component';

import { NumberOnlyDirective } from '../directives/number-only.directive';
import { LibraryService } from '../services/library.service';
import { EndpointsConfigService } from '../services/endpoints-config.service';
import { HttpClientService } from '../services/http-client.service';
import { CustomerSnackbarComponent } from '../components/customer-snackbar/customer-snackbar.component';
import { CustomSnackbarService } from '../services/custom-snackbar.service';
import { FileDropComponent } from '../components/file-drop/file-drop.component';
import { ProgressComponent } from '../components/file-drop/progress/progress.component';
import { DndDirective } from '../components/file-drop/directive/dnd.directive';
import { DocumentTypeFilterPipe } from '../pipes/document-type-filter.pipe';
import { DisableDragndropDirective } from '../directives/disable-dragndrop.directive';
import { DynamicBadgePipe } from '../pipes/dynmaic-badge.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { AutoCompleteChipsComponent } from '../components/auto-complete-chips/auto-complete-chips.component';
import { PhoneFieldComponent } from '../components/phone-field/phone-field.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { ForgotPasswordCommomComponent } from '../components/forgot-password-commom/forgot-password-commom.component'
import { AutocompletePositionDirective } from '../directives/autocomplete-position.directive';
// import { CountryCode } from '../components/international-phone-number/data/country-code';
import { MatFormFieldControl } from '@angular/material/form-field';
// import { NgxMatIntlTelInputComponent } from '../components/international-phone-number/ngx-mat-intl-tel-input.component';
// import { phoneNumberValidator } from '../components/international-phone-number/ngx-mat-intl-tel-input.validator';
// import { SearchPipe } from '../components/international-phone-number/search.pipe';
import { CardInputComponent } from '../components/card-input/card-input.component';

@NgModule({
  declarations: [
    MultiSelectCheckboxComponent,
    DateFormatterPipe,
    DocumentTypeFilterPipe,
    ErrorMesssageComponent,
    AuthenticationPopupComponent,
    NumberOnlyDirective,
    CustomerSnackbarComponent,
    FileDropComponent,
    DndDirective,
    ProgressComponent,
    DisableDragndropDirective,
    DynamicBadgePipe,
    AutoCompleteChipsComponent,
    PhoneFieldComponent,
    ForgotPasswordCommomComponent,
    AutocompletePositionDirective,
    // NgxMatIntlTelInputComponent,
    // SearchPipe,
    CardInputComponent
  ],
  entryComponents:[CustomerSnackbarComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    TranslateModule,
    NgxIntlTelInputModule,
  ],
  exports: [
    MultiSelectCheckboxComponent,
    AutoCompleteChipsComponent,
    DateFormatterPipe,
    DocumentTypeFilterPipe,
    ErrorMesssageComponent,
    AuthenticationPopupComponent,
    PhoneFieldComponent,
    NgxIntlTelInputModule,
    ForgotPasswordCommomComponent,
    NumberOnlyDirective,
    CustomerSnackbarComponent,
    FileDropComponent,
    DndDirective,
    ProgressComponent,
    AngularMaterialModule,
    DisableDragndropDirective,
    DynamicBadgePipe,
    TranslateModule,
    AutocompletePositionDirective,
    // SearchPipe,
    CardInputComponent
  ],
  providers: [
    LibraryService,
    HttpClientService,
    EndpointsConfigService,
    CustomSnackbarService,
    // CountryCode
  ]
})
export class LibraryModule { }
